(function () {
  const initializeTabs = (root) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    const header = document.querySelector('[data-site-header]');
    const tablist = root.querySelector('[role="tablist"]');
    const syncHeaderHeight = () => root.style.setProperty('--tabs-header-height', `${header?.getBoundingClientRect().height || 0}px`);
    syncHeaderHeight();
    if (header) new ResizeObserver(syncHeaderHeight).observe(header);

    const activate = (nextTab, moveFocus) => {
      const wasSticky = matchMedia('(max-width: 700px)').matches && tablist.getBoundingClientRect().top <= (header?.getBoundingClientRect().bottom || 0) + 1;

      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== nextTab.getAttribute("aria-controls");
      });
      if (wasSticky) root.scrollIntoView({block: 'start', behavior: 'instant'});
      if (moveFocus) nextTab.focus({preventScroll: true});
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(tab, false));
      tab.addEventListener("keydown", (event) => {
        let nextIndex = index;
        if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
        else if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(tabs[nextIndex], true);
      });
    });

    activate(tabs.find((tab) => tab.getAttribute("aria-selected") === "true") || tabs[0], false);
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-fixed-sets-tabs]").forEach(initializeTabs);
  });
})();
